<h3>{{ 'EMAIL_STATS.LINK_ACTIVITY' | translate }}</h3>
<div class="link-tracking">
  <mat-accordion>
    <div *ngFor="let linkStat of linkActivity">
      <mat-expansion-panel #panel="matExpansionPanel">
        <mat-expansion-panel-header (click)="emitHighlightPreview(linkStat.url, !panel.expanded)">
          <mat-panel-title>
            <div class="title">{{ linkStat.displayUrl }}</div>
          </mat-panel-title>
          <mat-panel-description
            [matTooltip]="'EMAIL_STATS.LINK_CLICK_RATE_TOOLTIP' | translate"
            [matTooltipPosition]="'above'"
          >
            {{ linkStat.displayClickRate }}
          </mat-panel-description>
        </mat-expansion-panel-header>
        <div class="dropdown">
          {{ 'EMAIL_STATS.TOTAL_CLICKS' | translate }}
          <div class="stat">
            <b>{{ linkStat.totalClicks || 0 }}</b>
          </div>
        </div>
        <div class="dropdown">
          {{ 'EMAIL_STATS.UNIQUE_CLICKS' | translate }}
          <div class="stat">
            <b>{{ linkStat.uniqueClicks || 0 }}</b>
          </div>
        </div>
        <button
          mat-button
          class="see-contacts"
          [routerLink]="linkActivityPath"
          [queryParams]="{ url: linkStat?.url, backUrl: backUrl }"
        >
          {{ 'EMAIL_STATS.SEE_WHO_CLICKED' | translate }}
        </button>
      </mat-expansion-panel>
    </div>
  </mat-accordion>
</div>
